import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseURL } from "services/api";

// Importing types
import { AvailabilityDTO } from "./types";

const baseQuery = fetchBaseQuery({
  baseUrl: `${baseURL}/availability`,
  prepareHeaders: (headers) => {
    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");
    return headers;
  },
});

export const availabilityApi = createApi({
  reducerPath: "availabilityService",
  baseQuery,
  endpoints: (builder) => ({
    createAvailability: builder.mutation<any, Partial<AvailabilityDTO[]>>({
      query: (availabilities) => ({
        url: `/`,
        method: "POST",
        body: availabilities,
      }),
    }),
    deleteAvailability: builder.mutation<any, number>({
      query: (id: number) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
    }),
    upadateAvailability: builder.mutation<
      any,
      { id: number; availability: Partial<AvailabilityDTO> }
    >({
      query: ({ id, availability }) => ({
        url: `/${id}`,
        method: "PUT",
        body: availability,
      }),
    }),
  }),
});

export const {
  useCreateAvailabilityMutation,
  useDeleteAvailabilityMutation,
  useUpadateAvailabilityMutation,
} = availabilityApi;
